module.exports = __webpack_public_path__ + "media/images/dots_solo-6cc30b6e5eaf9362f6bbf2c03d8f8d72.png";